// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AudioController from "./audio_controller"
application.register("audio", AudioController)

import AudioTotalController from "./audio_total_controller"
application.register("audio-total", AudioTotalController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import QueuedAudioController from "./queued_audio_controller"
application.register("queued-audio", QueuedAudioController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)
